import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/seo";
import Layout from "../components/layout";
import RoachAboutPage from "../components/RoachAboutPage";

const About = (props) => {
  const pageData = props.data.contentfulPage;

  return (
    // The accreditation logo strip is rendered inside the page body (between
    // the story and the mission/vision cards) to match the design, so the
    // Layout copy that normally sits above the footer is turned off here.
    <Layout pageProps={props} footerLogoShowcase={false}>
      <SEO
        title={pageData.metaTitle}
        description={pageData.metaDescription}
        keywords={pageData.metaKeywordsList ? pageData.metaKeywordsList : []}
        robots={pageData.metaRobotsContent}
      />
      <RoachAboutPage page={pageData} />
    </Layout>
  );
};

export default About;

export const pageQuery = graphql`
  query aboutPageQuery {
    contentfulPage(slug: { eq: "about/" }) {
      id
      pageTitle
      metaTitle
      metaDescription
      slug
      metaKeywordsList
      metaRobotsContent

      team {
        id
        title
        description
        gatsbyImageData(width: 370, quality: 90)
      }

      body {
        body
      }
    }
  }
`;
